// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wgKQ","top":"styles_top__3SToc","left":"styles_left__2OJKx","description":"styles_description__1wTEG"};